import { defaultConfig } from '../types';
import { isSupport, isSupportInterlace, isSupportResize, isSupportQuality, } from './isSupport';
export const MAX_SIZE = 4096;
export const MIN_SIZE = 1;
export const MAX_PERCENTAGE = 1000;
export const MIN_PERCENTAGE = 1;
export const Noop = (r) => r;
var ProcessType;
(function (ProcessType) {
    ProcessType["resize"] = "resize";
    ProcessType["format"] = "format";
    ProcessType["blur"] = "blur";
    ProcessType["rotate"] = "rotate";
    ProcessType["quality"] = "quality";
    ProcessType["watermark"] = "watermark";
    ProcessType["crop"] = "crop";
    ProcessType["interlace"] = "interlace";
})(ProcessType || (ProcessType = {}));
const resize = ({ url, getRealLayoutSize = Noop, getPixelSizeForLayoutSize = Noop, }, resizeOptions) => {
    if (!isSupportResize(url)) {
        return '';
    }
    const { width = 0, height = 0, mode = 'lfit', percentage = 0, limit = 1, long = 0, short = 0, color, } = resizeOptions;
    const getSize = (v) => Math.floor(getPixelSizeForLayoutSize(getRealLayoutSize(v)));
    const list = [];
    // 先将设计尺寸换成实际布局尺寸，再转换为像素尺寸
    if (width > 0) {
        let w = getSize(width);
        w = w < MIN_SIZE ? MIN_SIZE : w > MAX_SIZE ? MAX_SIZE : w;
        list.push(`w_${w}`);
    }
    if (height > 0) {
        let h = getSize(height);
        h = h < MIN_SIZE ? MIN_SIZE : h > MAX_SIZE ? MAX_SIZE : h;
        list.push(`h_${h}`);
    }
    if (long >= MIN_SIZE && long <= MAX_SIZE) {
        list.push(`l=${long}`);
    }
    if (short >= MIN_SIZE && short <= MAX_SIZE) {
        list.push(`s=${short}`);
    }
    if (percentage >= MIN_PERCENTAGE && percentage <= MAX_PERCENTAGE) {
        list.push(`p_${percentage}`);
    }
    if (color && mode === 'pad') {
        list.push(`color_${color}`);
    }
    const size = list.join(',');
    return size ? `resize,${size},m=${mode},limit=${limit}` : '';
};
const changeQuality = ({ url }, { quality }) => {
    // 不支持quality或者不合法的quality则不设置quality
    if (!isSupportQuality(url) || !quality || quality < 1) {
        return '';
    }
    const q = quality > 100 ? 100 : quality;
    return `quality,Q_${q}`;
};
const setInterlace = ({ url }) => isSupportInterlace(url) ? 'interlace,1' : '';
const convertFormat = ({ format }) => {
    return format ? `format,${format}` : '';
};
const processCdnOptions = (options) => {
    const { url } = options || {};
    // 必须转换成https的
    const _url = url === null || url === void 0 ? void 0 : url.replace('http:', 'https:');
    // 判断图片服务是否支持
    if (!isSupport(_url)) {
        return _url;
    }
    // 合并配置
    const config = Object.assign(Object.assign({}, defaultConfig), options);
    const { cdnOptions = [] } = config;
    const params = cdnOptions.reduce((list, option) => {
        let param = '';
        const processType = option === null || option === void 0 ? void 0 : option.type;
        if (processType === ProcessType.resize) {
            param = resize(config, option.params);
        }
        else if (processType === ProcessType.quality) {
            const options = Object.assign({ quality: config.quality }, option.params);
            param = changeQuality(config, options);
        }
        else if (processType === ProcessType.interlace &&
            option.params === 1) {
            param = setInterlace(config);
        }
        else if (processType === ProcessType.format) {
            param = convertFormat({ format: option.params });
        }
        return param ? [...list, param] : list;
    }, []);
    return params.length > 0
        ? `${_url}?x-oss-process=image/${params.join('/')}`
        : _url;
};
const process = (url, options) => {
    if (!options) {
        return url;
    }
    const cdnOptions = [
        {
            type: ProcessType.resize,
            params: options,
        },
        {
            type: ProcessType.quality,
            params: options,
        },
    ];
    // interlace 默认为0
    const interlace = options.interlace || 0;
    // 如果设置了渐变，确保先转换成jpeg
    if (interlace === 1) {
        cdnOptions.push({
            type: ProcessType.format,
            params: 'jpeg', // TODO: 是否需要判断环境
        }, {
            type: ProcessType.interlace,
            params: interlace,
        });
    }
    return processCdnOptions({
        url,
        cdnOptions,
    });
};
export default process;
